import { api, ExaminerAddress, ExaminerContactDetails } from 'api';
import { rtkQueryApi } from 'store/rtkQueryApi';

type SaveContactDetailsParams = {
  examinerId: number;
  data: ExaminerContactDetails;
};

type ValidatePostCodeParams = {
  propertyName: string;
  address: ExaminerAddress;
};

const examinerContactDetailsApi = rtkQueryApi.injectEndpoints({
  endpoints: (builder) => ({
    getExaminerContactDetails: builder.query<ExaminerContactDetails, number>({
      query: (examinerId) => api.examiner.getExaminerContactDetails({ examinerId }),
      providesTags: ['ExaminerContactDetails'],
    }),

    saveExaminerContactDetails: builder.mutation<void, SaveContactDetailsParams>({
      query: ({ examinerId, data }) =>
        api.examiner.saveExaminerContactDetails({ examinerId }, data),
      invalidatesTags: ['ExaminerContactDetails', 'Examiner'],
    }),

    validatePostCode: builder.mutation<ExaminerAddress, ValidatePostCodeParams>({
      query: ({ propertyName, address }) =>
        api.examiner.validatePostCodeAndGetAddress(address, { propertyName }),
    }),
  }),
});

export const {
  useGetExaminerContactDetailsQuery,
  useSaveExaminerContactDetailsMutation,
  useValidatePostCodeMutation,
} = examinerContactDetailsApi;
